import { RootState } from './../rootReducer'

export const selectResponseType = (rootState: RootState) =>
  rootState?.logRequestState?.responseType

export const selectResponseData = (rootState: RootState) =>
  rootState?.logRequestState?.responseData
